import React, { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Stack } from '@lyearn/ui';
import ContentItem from '@/modules/corporate/modules/path/views/PathEditor/components/ContentItem';
import { ContentEntity, DueDateAssignmentConfig, DueDateNestingLevelEnum } from '@/types/schema';

import { RenderDueDate } from '../../renderer';

interface ContentDetailsProps {
  content: ContentEntity;
  onSetDueDateForContent: (
    content: ContentEntity,
    dueDateNestingLevel?: DueDateNestingLevelEnum | undefined,
    isNested?: boolean,
  ) => void;
  dueDateConfig?: DueDateAssignmentConfig | null;
}

function ContentDetails(props: ContentDetailsProps) {
  const { t } = useTranslation();
  const { content, onSetDueDateForContent, dueDateConfig } = props;
  const onSetContentDueDate = useCallback(() => {
    onSetDueDateForContent(content, undefined, true);
  }, [content, onSetDueDateForContent]);

  return (
    <Stack
      alignItems="center"
      className="border-b border-solid border-interactive-border py-16"
      justifyContent="between">
      <ContentItem content={content} />
      <RenderDueDate selectedDueDate={dueDateConfig} t={t} onClick={onSetContentDueDate} />
    </Stack>
  );
}

export default ContentDetails;
